import { styled } from "@mui/material/styles";
import { Button, Container } from "../style";
import { CssTextField } from "../../style";
const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "50px",
  margin: "0px 100px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    margin: "0px 10px",
  },
}));
const ContentDialog = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  padding: "15px",
}));
const BoxDialog = styled("div")(({ theme }) => ({
  display: "flex",
  m: "auto",
  position: "relative",
}));
const ButtonCancel = styled("button")(({ theme }) => ({
  backgroundColor: "#9F9F9F",
  margin: "15px",
  textAlign: "center",
  padding: "5px",
  paddingLeft: "18px",
  paddingRight: "18px",
  borderRadius: "18px",
  border: "0px",
  color: "white",
  "&:hover": {
    backgroundColor: "#D2D1D1",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const OneColumn = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  padding: "15px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },
}));
const H5 = styled("h5")(({ theme }) => ({
  width: "100%",
  padding: "55px 0px",
  [theme.breakpoints.down("sm")]: {
    padding: "35px 0px",
  },
}));
const ThreeColumn = styled(OneColumn)(({ theme }) => ({
  width: "32%",
  padding: "0px",
  minHeight: "90px",
  marginBottom: "0px",
  [theme.breakpoints.down("md")]: {
    width: "90%",
    maxWidth: "100%",
  },
}));
const FourColumn = styled(OneColumn)(({ theme }) => ({
  width: "23%",
  padding: "0px",
  minHeight: "90px",
  marginBottom: "0px",
  [theme.breakpoints.down("lg")]: {
    width: "90%",
    maxWidth: "100%",
  },
}));
const TwoColumn = styled(OneColumn)(({ theme }) => ({
  width: "48%",
  padding: "0px",
  minHeight: "90px",
  marginBottom: "0px",
  [theme.breakpoints.down("lg")]: {
    width: "90%",
    maxWidth: "100%",
  },
}));
const BorderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  border: "1px solid #f0f0f0",
  borderRadius: "15px",
  margin: "35px",
  boxShadow: "10px 5px 5px #efe2e2",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "8px",
  },
}));
const ContractorContainer = styled(Container)(({ theme }) => ({
  width: "100%",
  border: "1px solid #f0f0f0",
  borderRadius: "15px",
  padding: "10px",
}));
const ContractorThreeColumn = styled(ThreeColumn)(({ theme }) => ({
  minHeight: "75px",
}));
const ContractorCssTextField = styled(CssTextField)(({ theme }) => ({
  "& label.Mui-disabled": {
    color: "black",
  },
  "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "black",
    },
}));
const LabelH6 = styled("h6")(({ theme }) => ({
  textAlign: "left",
  paddingLeft: "15px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));
const AlertSpan = styled("span")(({ theme }) => ({
  color: "red",
  fontSize: "15px",
}));
const AddButton = styled(Button)({
  marginTop: "5px",
  width: "80%",
});
// const stylesCss = {
//   root: {},
//   radioGroup: {
//     alignItems: "center",
//   },
//   radio: {
//     color: "#FF0000",
//     "&.Mui-checked": {
//       color: "#FF0000",
//     },
//   },
// };
const stylesCss = {
  root: {
    "& .MuiStepIcon-root.Mui-active": { color: "red" },
    "& .MuiStepIcon-root.Mui-completed": { color: "#FF0000" },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ffcdd2" },
    // ["@media (min-width:420px)"]: {
    //   flexDirection: "column",
    // },
  },
  card: {
    textAlign: "center",
  },
  radioGroup: {
    alignItems: "center",
  },
  radio: {
    color: "#FF0000",
    "&.Mui-checked": {
      color: "#FF0000",
    },
  },
  btnBuscarRegresar: {
    backgroundColor: "red",
    borderRadius: "13px",
    height: "60px",
    padding: "15px 30px 15px 30px",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      opacity: [0.9, 0.8, 0.7],
      color: "black",
    },
  },
  gridBtnContinuar: {
    textAlign: "left",
  },
};

export default stylesCss;
export {
  Root,
  H5,
  ContentDialog,
  BoxDialog,
  ButtonCancel,
  BorderContainer,
  ContractorContainer,
  ContractorThreeColumn,
  ContractorCssTextField,
  OneColumn,
  TwoColumn,
  ThreeColumn,
  FourColumn,
  LabelH6,
  AddButton,
  AlertSpan,
};
